import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import { IconButton } from 'components/Button';
import './index.sass';

const { block, el } = bem('office-empty-block');
const OfficeEmptyBlock = ({primaryText, secondaryText, buttonText, onClick, link, icon}) => {
    return (
        <div className={block()}>
            <div className={el('smiley')}>
                <Icon name={'smiley'}/>
            </div>
            <div className={el('text')}>
                <div className={el('text-primary')}><Text serif>{primaryText}</Text></div>
                <div className={el('text-secondary')}><Text>{secondaryText}</Text></div>
            </div>
            <div className={el('button')}>
                <IconButton mod={'gold'} name={icon} onClick={onClick} to={link}>
                    <Text>{buttonText}</Text>
                </IconButton>
            </div>
        </div>
    )
}

export default OfficeEmptyBlock;
